import StaffForm from "@app/components/forms/staff/staff-form.tsx";
import { PageContainer } from "@app/components/page-container.tsx";
import { createFileRoute } from "@tanstack/react-router";

interface SearchParams {
    tab?: string;
}

export const Route = createFileRoute("/_authenticated/_manager/staff/create")({
    component: RouteComponent,
    validateSearch: (search: Record<string, unknown>): SearchParams => {
        return {
            tab: search.tab as string | undefined,
        };
    },
});

function RouteComponent() {
    const { tab } = Route.useSearch();

    return (
        <PageContainer title={"Create Staff"}>
            <StaffForm initialTab={tab} />
        </PageContainer>
    );
}
